import useFeatureAccess from './useFeatureAccess';

const useFeatureEnabled = featureKey => {
  const { features } = useFeatureAccess();
  return Boolean(features?.[featureKey]);
};

export default useFeatureEnabled;
